var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "firmware-input-component device-row-details" },
    [
      _c(
        "div",
        { staticClass: "ring-card__input-label" },
        [
          _c("h3", { staticStyle: { display: "inline-block" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("capitalize")(_vm.component.name)) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                effect: "dark",
                content: _vm.tooltipText,
                placement: "top-start",
              },
            },
            [
              _c("i", {
                class: _vm.iconName,
                staticStyle: { "margin-left": "1rem" },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "ring-card__input",
          staticStyle: { width: "max-content" },
        },
        [
          _vm.editMode === false
            ? _c("span", [
                _vm._v(_vm._s(_vm.currentFirmware.version || "Not set")),
              ])
            : _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    placeholder: "Not set",
                    filterable: "",
                    disabled: !_vm.editMode,
                  },
                  model: {
                    value: _vm.component.newVersionSelected,
                    callback: function ($$v) {
                      _vm.$set(_vm.component, "newVersionSelected", $$v)
                    },
                    expression: "component.newVersionSelected",
                  },
                },
                _vm._l(_vm.fwGroupedByRelease, function (group) {
                  return _c(
                    "el-option-group",
                    { key: group.label, attrs: { label: group.label } },
                    _vm._l(group.options, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.version, value: item.version },
                      })
                    }),
                    1
                  )
                }),
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("small", { staticStyle: { color: "forestgreen" } }, [
        _vm._v("\n    Running " + _vm._s(_vm.runningFirmware) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }